const firebaseConfig = {
  apiKey: "AIzaSyAOM3PbxVG6jAIM0LhLM7ZQK748EN5day8",
  authDomain: "express-tickets-001.firebaseapp.com",
  projectId: "express-tickets-001",
  storageBucket: "express-tickets-001.appspot.com",
  messagingSenderId: "455772537998",
  appId: "1:455772537998:web:7553138ebaed0aeef775df"
};

export default firebaseConfig;